export default __webpack_public_path__ + "f41ed3b78d5ccb0522bd8c83d5104de3.gif";